import React, { useEffect, useState } from 'react';
import { Layout } from 'antd';
import './MobilePage.scss'
import * as Utilities from '../../Utilities'


import CustomHeader from '../../CustomHeader';

const { Header, Content } = Layout;

export default function MobilePage({children}) {
    const [isMobileDevice, setMobileDevice] = useState(false)

    // Add paths you want to    allow on mobile
    const allowedMobilePaths = ['/', '/reset', '/change_password', '/login', '/register', '/card-save-complete', '/reset', '/360_public_viewer', '/3d_tour_viewer', '/android', '/select-subscription'];


    useEffect(() => {
        if(Utilities.deviceType() == 'mobile' && !allowedMobilePaths.includes(window.location.pathname)){
            setMobileDevice(true)
        }
    }, [])
    
    return (
        isMobileDevice ?
        <>
            <Header className="gx-app-header">
                <CustomHeader />
            </Header>
            <Layout className="gx-app-main">
                <Content className={`gx-layout-content customer-main-layout-pd-0 `}>
                    <div className='mobile-page-container' style={{overflow: 'hidden'}}>
                        <div style={{paddingTop: 70, paddingLeft: 20, paddingRight: 20, textAlign: 'left'}}>
                            <div className='manrope f-16 w-700'>
                                Welcome to ALL3D
                            </div>
                            <div className='manrope f-24 w-700 mt-10' style={{textAlign: 'left'}}>
                                Currently, our platform features are only available on desktop
                            </div>

                            <div className='manrope f-14 w-500 mt-10' style={{textAlign: 'left'}}>
                                To get the best experience, please log in to app.all3d.ai on desktop for access to your ALL3D dashboard, our 3D services, and other features.
                            </div>

                            <div className='mt-20' style={{marginLeft : '-5px'}}>
                                <img src="/img/browser-window.png" alt="" />
                            </div>
                        </div>
                    </div>
                </Content>
            </Layout>

        </>
        :
        <>{children}</>
    )
}
